export const DEFAULT_AUTHOR = 'Jennifer Henderson';

export const BLOG_LOCATIONS = ['Los Angeles', 'Charlotte', 'Nationwide'];

export const BLOG_EVENT_TYPES = [
  'Weddings',
  'Corporate Events',
  'Private Parties',
  'Non-Profit & Government',
  'Celebrity & VIP',
  'Event Planning',
];

export const BLOG_CONTENT_TYPES = [
  'Guide',
  'News',
  'Interview',
  'Case Study',
  'Video',
  'Expert Advice',
];

export const BLOG_SERVICES = [
  'Wedding Planning',
  'Wedding Venues',
  'Wedding Flowers',
  'Wedding Themes',
  'Marriage Proposal',
  'Corporate Event Planning',
  'Product Launches',
  'Corporate Retreats',
  'Conferences and Seminars',
  'Corporate Galas',
  'Networking Events',
  'Event Planning Services',
  'Event Production',
  'Event Technology',
  'Event Decor',
  'Photo Booths',
  'Birthday Party Planning',
  'Bachelorette Parties',
  'Fundraisers and Galas',
  'Government Events',
  'Red Carpet Events',
  'Celebrity Events',
  'VIP Events',
];

export const LEGACY_TAG_OPTIONS = [
  'Music',
  'Accordion',
  'Learning',
  'History',
  'Entertainment',
  'Events',
  'Experts',
  'Other',
];

export const TAXONOMY_TAG_OPTIONS = [
  ...BLOG_LOCATIONS,
  ...BLOG_EVENT_TYPES,
  ...BLOG_CONTENT_TYPES,
  ...BLOG_SERVICES,
];

export const getTaxonomySelectionFromTags = (tags = []) => ({
  location: BLOG_LOCATIONS.find((item) => tags.includes(item)) || '',
  eventType: BLOG_EVENT_TYPES.find((item) => tags.includes(item)) || '',
  contentType: BLOG_CONTENT_TYPES.find((item) => tags.includes(item)) || '',
  service: BLOG_SERVICES.find((item) => tags.includes(item)) || '',
});

export const mergeTaxonomyTags = (tags = [], taxonomy = {}) => {
  const taxonomyValues = [
    taxonomy.location,
    taxonomy.eventType,
    taxonomy.contentType,
    taxonomy.service,
  ].filter(Boolean);
  const legacyTags = tags.filter((tag) => !TAXONOMY_TAG_OPTIONS.includes(tag));

  return [...new Set([...taxonomyValues, ...legacyTags])];
};
